import { RoutesPaths } from "../../../constants/routes.ts"
import type { GuideTour } from "../types/guide-content.types.ts"

export const GUIDE_TOURS: GuideTour[] = [
  {
    id: "leads-pipeline",
    moduleSlug: "leads",
    titleKey: "guide.tours.leadsPipeline.title",
    route: RoutesPaths.lead.list,
    steps: [
      {
        id: "pipeline-header",
        target: "leads-pipeline-header",
        titleKey: "guide.tours.leadsPipeline.steps.header.title",
        bodyKey: "guide.tours.leadsPipeline.steps.header.body",
        placement: "bottom"
      },
      {
        id: "pipeline-kpis",
        target: "leads-pipeline-kpis",
        titleKey: "guide.tours.leadsPipeline.steps.kpis.title",
        bodyKey: "guide.tours.leadsPipeline.steps.kpis.body",
        placement: "bottom"
      },
      {
        id: "pipeline-import-export",
        target: "leads-pipeline-import-export",
        titleKey: "guide.tours.leadsPipeline.steps.importExport.title",
        bodyKey: "guide.tours.leadsPipeline.steps.importExport.body",
        placement: "left"
      },
      {
        id: "pipeline-table",
        target: "leads-pipeline-table",
        titleKey: "guide.tours.leadsPipeline.steps.table.title",
        bodyKey: "guide.tours.leadsPipeline.steps.table.body",
        placement: "top"
      }
    ]
  }
]

export const getGuideTour = (id: string): GuideTour | null =>
  GUIDE_TOURS.find((tour) => tour.id === id) ?? null

/**
 * Narrows a tour's steps to what this user's permissions actually grant.
 * No tour in `GUIDE_TOURS` currently declares step-level requirements (the
 * one that did, `platform-tour`, was replaced by the route/tab/record-aware
 * ProductTourContext — see tour/ProductTourContext.tsx) — every tour here
 * is returned unchanged. Kept as the one seam a future contextual tour with
 * its own step-level gating would extend, rather than removed outright.
 */
export const getAccessibleTour = (
  tour: GuideTour,
  _pages: readonly string[] | null | undefined
): GuideTour => tour
